<template>
  <v-main>
    <GenericReport
      ref="report"
      orientation="horizontal"
      hide-header
      class="clean-list"
      :reportSpec="reportSpec"
      @rowClicked="go"
    >
      <template v-slot:topbar-actions>
        <v-spacer />
        <v-btn color="primary" @click="newCustomer">
          Novo Cliente...
        </v-btn>
        <v-btn icon @click="doDownload" title="Exportar para Excel">
          <v-icon>mdi-microsoft-excel</v-icon>
        </v-btn>
      </template>
    </GenericReport>
  </v-main>
</template>

<script>
import GenericReport from 'oderon-vue/cpts/generic-report/GenericReport.vue'
import { Customer } from '@/models'

export default {
  pageTitle: 'Clientes',
  components: { GenericReport },
  data() {
    return {
      reportSpec: {
        code: 'customers',
        title: 'Clientes',
        apiBase: '/customers',
        filters: [
          {
            type: 'Text',
            prefix: 'keywords',
            icon: 'mdi-magnify',
            size: 'md',
            debounceMs: 250
          },
          {
            type: 'Switch',
            prefix: 'includeInactive',
            label: 'Mostrar inativos'
          }
        ]
      }
    }
  },

  methods: {
    async newCustomer() {
      let label = await this.$prompt({
        label: 'Informe o nome do novo cliente:'
      })

      if (label == null) return null

      await this.$loading(async () => {
        let row = await Customer.save({ label })
        this.$router.push(`/customers/${row.id}`)
      })
    },

    go({ row, isMiddle }) {
      if (isMiddle) {
        window.open(`/#/customers/${row.id}`, '_blank')
      } else {
        this.$router.push(`/customers/${row.id}`)
      }
    },

    doDownload() {
      this.$refs.report.downloadExcel()
    }
  }
}
</script>

<style></style>
